import type { ICargoCommentAddResponse, ICargoCommentItem } from '~~/shared/interfaces/cargoComment';

export const useCargoCommentStore = defineStore('cargo-comment', () => {
	const loading = reactive({
		getByCargoComment: false,
		addCargoComment: false,
		deleteCargoComment: false
	});

	function $reset() {}

	const getByCargoComment = async (payload: { cargoId: string }) => {
		const { data, status } = await useCustomFetch<ICargoCommentItem[]>(
			'/api/CargoComment/get-by-cargo',
			{
				query: payload
			},
			{
				setLoading: (load: boolean) => {
					loading.getByCargoComment = load;
				}
			}
		);

		return { data: data.value, status: status.value };
	};

	const addCargoComment = async (payload: ICargoCommentAddResponse) => {
		const { data, status } = await useCustomFetch<ICargoCommentItem>(
			'/api/CargoComment/add',
			{
				method: 'POST',
				body: payload
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.addCargoComment = load;
					}
				}
			}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	const cargoCommentDelete = async (payload: { id: string }) => {
		const { data, status } = await useCustomFetch<ICargoCommentItem>(
			'/api/CargoComment/delete',
			{
				method: 'delete',
				query: payload
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.deleteCargoComment = load;
					}
				}
			}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	return {
		loading,
		$reset,
		addCargoComment,
		cargoCommentDelete,
		getByCargoComment,
		getCargoComments: getByCargoComment
	};
});
